<div class="margin-y-1" *ngIf="isBreadcrumbShown">
    <div class=" display-inline-block">

            <div [attr.aria-label]="'remove filter ' + queryCategory.displayValue" *ngFor="let queryCategory of queryCategories" style="display: inline">

                <button class="usa-button usa-button--outline breadcrumb-delete-btn" (click)="deleteQueryCategory(queryCategory.type)">X
                </button>
                <span>{{queryCategory.displayValue}}</span>
                <div *ngFor="let queryValue of queryCategory.queryValues" [attr.aria-label]="'remove filter ' + queryValue.value" tabindex="0" class="afs-cursor-pointer" style="display: inline" (keypress)="deleteQueryValue(queryValue.value,queryCategory.type)" (focus)="showDelIcon($event)" (blur)="hideDelIcon($event)" (mouseleave)="hideDelIcon($event)" (mouseenter)="showDelIcon($event)">
                    &nbsp;
                    <a class="usa-link" (click)="deleteQueryValue(queryValue.value,queryCategory.type)">
                        <span  style="visibility: hidden; display:none;">
                            <svg class="usa-icon hover-display" role="img">
                                <use xlink:href="./assets/img/sprite.svg#highlight_off"></use>
                            </svg>
                        </span>
                        <span>{{queryValue.displayValue}}</span>
                    </a>
                </div>
                &nbsp;
            </div>

    </div>
</div><!-- CLOSE .info-banner -->